

























































































































































































import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import userSettings from "@/components/userSettings.vue";
import teamInfo from "@/components/teamInfo.vue";
import lessonCompletionBar from "@/components/lessons/lessonCompletionBarChart.vue";
import lessonStatSummary from "@/components/lessons/lessonStatSummary.vue";
import consts from "../../consts";
import { User, UserStat } from "../../types";
import axios from "axios";
import { Getter } from "vuex-class";

@Component({
  components: {
    userSettings,
    teamInfo,
    lessonCompletionBar,
    lessonStatSummary
  }
})
export default class LessonStats extends Vue {
  @Prop() private JWT!: string;
  @Getter private currentTeamID!: string;
  @Prop() private currentTeam!: any;
  @Prop() private currentTeamUsers!: User[];
  @Prop() private currUser!: User;
  @Prop() private userStats!: UserStat[];

  private lessonStatsData: any = null;
  private dataFetched: boolean = false;
  private lessonFilter: string = "";
  private currentLesson: number = 0;
  private completionData: number[] = [15];
  private colors: string[] = ["#38D17A", "#00b4e3", "#ffcc00", "#f74657"];
  private activityCurrentPage: number = 1;
  private totalRows: number =
    this.lessonStatsData && this.lessonStatsData.ActivityHistory
      ? this.lessonStatsData.ActivityHistory.length
      : 0;
  private activityFilter: string = "";
  private fields: any = {
    LessonTitle: {
      label: "Lessons",
      sortable: true
    },
    CompletionRate: {
      label: "Completion Rate",
      sortable: true
    },
    AvgScore: {
      label: "Average Score",
      sortable: true
    },
    AvgFillerCount: {
      label: "Average Fillers",
      sortable: true
    },
    AvgWPM: {
      label: "Average Pace (WPM)",
      sortable: true
    },
    AvgClarityScore: {
      label: "Clarity (%)",
      sortable: true
    },
    AvgEnergyScore: {
      label: "Energy (%)",
      sortable: true
    }
  };
  private created() {
    this.fetchLessonStats();
  }

  private fetchLessonStats() {
    if (this.currentTeamID) {
      axios
        .get(
          consts.serverURL +
            "team/" +
            this.currentTeamID +
            "/combined-lesson-exercise",
          { headers: { Authentication: this.JWT } }
        )
        .then(resp => {
          console.log("LESSON STATS", resp.data);
          this.lessonStatsData = resp.data;
          if (this.lessonStatsData && this.lessonStatsData.ActivityHistory) {
            this.totalRows = this.lessonStatsData.ActivityHistory.length;
          }

          // Add lesson completion keys
          if (this.lessonStatsData && this.lessonStatsData.LessonCompletion) {
            for (
              let i = 0;
              i < this.lessonStatsData.LessonCompletion.length;
              ++i
            ) {
              this.lessonStatsData.LessonCompletion[i].index = i;
            }
          }

          this.dataFetched = true;
        })
        .catch(error => {
          console.log(error, error.response);
          this.dataFetched = true;
        });
    }
  }

  get filteredLessons() {
    if (this.lessonStatsData && this.lessonStatsData.LessonCompletion) {
      return this.lessonStatsData.LessonCompletion.filter((lesson: any) => {
        if (lesson.Title) {
          let title = lesson.Title.toLowerCase();
          return title.indexOf(this.lessonFilter.toLowerCase()) >= 0;
        }
        return false;
      });
    }
    return [];
  }

  private decimalToPercent(dec: number) {
    return Math.round(dec * 100);
  }

  private onFiltered(filteredItems: any[]) {
    // Trigger pagination to update the number of buttons/pages due to filtering
    this.totalRows = filteredItems.length;
    this.activityCurrentPage = 1;
  }

  @Watch("currentTeamID")
  private onCurrentTeamIdChanged() {
    this.fetchLessonStats();
  }
}
